export interface RespostaGraficoVariaveis {
	conteudoAguaSolo10cm: number[];
	conteudoAguaSolo20cm: number[];
	conteudoAguaSolo30cm: number[];
	conteudoAguaSolo40cm: number[];
	conteudoAguaSolo50cm: number[];
	conteudoAguaSolo60cm: number[];
	correnteRecarga: number[];
	data: number[];
	evapotranspiracaoPotencial: number[];
	precipitacao: number[];
	pressao: number[];
	pressaoAtmosferica: number[];
	radiacao: number[];
	sensorPortaAberta: number[];
	temperaturaAr: number[];
	temperaturaInterna: number[];
	temperaturaSolo: number[];
	temperaturaSolo10cm: number[];
	temperaturaSolo20cm: number[];
	temperaturaSolo30cm: number[];
	temperaturaSolo40cm: number[];
	temperaturaSolo50cm: number[];
	temperaturaSolo60cm: number[];
	tensaoBateria: number[];
	umidadeAr: number[];
	umidadeInterna: number[];
	umidadeSolo: number[];
	vento2m: number[];
	ventoDirecao: number[];
	ventoDirecao1DesvioPadrao: number[];
	ventoDirecao1NaMaxima: number[];
	ventoDirecao2: number[];
	ventoDirecao2DesvioPadrao: number[];
	ventoDirecao2NaMaxima: number[];
	ventoVelocidade: number[];
	ventoVelocidade1Maxima: number[];
	ventoVelocidade2Maxima: number[];
	temperaturaMaxima: number[];
	temperaturaMinima: number[];
	umidadeMaxima: number[];
	umidadeMinima: number[];
}
export class ConfiguracaoGrafico {
	constructor(
		readonly render: string,
		readonly titulo: string,
		readonly subTitulo: string,
		readonly descritivoDados: string,
		readonly configuracoesExtras: any
	) {}
}

export enum Variavel {
	CONTEUDO_AGUA_SOLO_10CM = 'Conteúdo de água no solo 10cm',
	CONTEUDO_AGUA_SOLO_20CM = 'Conteúdo de água no solo 20cm',
	CONTEUDO_AGUA_SOLO_30CM = 'Conteúdo de água no solo 30cm',
	CONTEUDO_AGUA_SOLO_40CM = 'Conteúdo de água no solo 40cm',
	CONTEUDO_AGUA_SOLO_50CM = 'Conteúdo de água no solo 50cm',
	CONTEUDO_AGUA_SOLO_60CM = 'Conteúdo de água no solo 60cm',
	PRECIPITACAO = 'Precipitação',
	EVAPOTRANSPIRACAO = 'Evapotranspiração',
	PRESSAO_ATMOSFERICA = 'Pressão atmosférica',
	RADIACAO_SOLAR = 'Radiação solar',
	TEMPERATURA_DO_AR = 'Temperatura do ar',
	TEMPERATURA_MAXIMA = 'Temperatura máxima',
	TEMPERATURA_MINIMA = 'Temperatura mínima',
	TEMPERATURA_DO_SOLO_10CM = 'Temperatura do solo à 10 cm',
	TEMPERATURA_DO_SOLO_20CM = 'Temperatura do solo à 20 cm',
	TEMPERATURA_DO_SOLO_30CM = 'Temperatura do solo à 30 cm',
	TEMPERATURA_DO_SOLO_40CM = 'Temperatura do solo à 40 cm',
	TEMPERATURA_DO_SOLO_50CM = 'Temperatura do solo à 50 cm',
	TEMPERATURA_DO_SOLO_60CM = 'Temperatura do solo à 60 cm',
	TEMPERATURA_INTERNA = 'Temperatura interna',
	UMIDADE_DO_AR = 'Umidade do ar',
	UMIDADE_MAXIMA = 'Umidade máxima',
	UMIDADE_MINIMA = 'Umidade mínima',
	UMIDADE_INTERNA = 'Umidade interna',
	TENSAOBATERIA = 'Tensão da bateria',
	SENSOR_PORTA_ABERTA = 'Sensor de porta aberta',
	VENTO_DIRECAO_1 = 'Vento direção à 2 metros',
	VENTO_DIRECAO_2 = 'Vento direção à 10 metros',
	VENTO_VELOCIDADE_1 = 'Vento em 2 metros',
	VENTO_VELOCIDADE_2 = 'Vento em 10 metros',
	VENTO_VELOCIDADE_1_MAXIMA = 'Vento velocidade a 2 metros máxima',
	VENTO_VELOCIDADE_2_MAXIMA = 'Vento velocidade a 10 metros máxima',
	VENTO_DIRECAO_1_NA_MAXIMA = 'Vento direção a 2 metros na máxima',
	VENTO_DIRECAO_2_NA_MAXIMA = 'Vento direção a 10 metros na máxima',
	VENTO_DIRECAO_1_DESVIO_PADRAO = 'Vento direção a 2 metros desvio padrão',
	VENTO_DIRECAO_2_DESVIO_PADRAO = 'Vento direção a 10 metros desvio padrão',
}

export enum VariavelUnidade {
	CONTEUDO_AGUA_SOLO_10CM = '(%)',
	CONTEUDO_AGUA_SOLO_20CM = '(%)',
	CONTEUDO_AGUA_SOLO_30CM = '(%)',
	CONTEUDO_AGUA_SOLO_40CM = '(%)',
	CONTEUDO_AGUA_SOLO_50CM = '(%)',
	CONTEUDO_AGUA_SOLO_60CM = '(%)',
	PRECIPITACAO = '(mm)',
	EVAPOTRANSPIRACAO = '(mm)',
	PRESSAO_ATMOSFERICA = '(hPa)',
	RADIACAO_SOLAR = '(W/m²)',
	TEMPERATURA_DO_AR = '(°C)',
	TEMPERATURA_MAXIMA = '(°C)',
	TEMPERATURA_MINIMA = '(°C)',
	TEMPERATURA_DO_SOLO = '(°C)',
	TEMPERATURA_DO_SOLO_10CM = '(°C)',
	TEMPERATURA_DO_SOLO_20CM = '(°C)',
	TEMPERATURA_DO_SOLO_30CM = '(°C)',
	TEMPERATURA_DO_SOLO_40CM = '(°C)',
	TEMPERATURA_DO_SOLO_50CM = '(°C)',
	TEMPERATURA_DO_SOLO_60CM = '(°C)',
	TEMPERATURA_INTERNA = '(°C)',
	UMIDADE_DO_AR = '(%)',
	UMIDADE_MAXIMA = '(%)',
	UMIDADE_MINIMA = '(%)',
	UMIDADE_INTERNA = '(%)',
	TENSAOBATERIA = '(V)',
	UMIDADE_SOLO = '(%)',
	VENTO_10M = '(m/s)',
	VENTO_DIRECAO_1 = '(°)',
	VENTO_DIRECAO_2 = '(°)',
	VENTO_DIRECAO_1_NA_MAXIMA = '(°)',
	VENTO_DIRECAO_2_NA_MAXIMA = '(°)',
	VENTO_2_MAXIMA = '(m/s)',
	VENTO_VELOCIDADE_1_MAXIMA = '(m/s)',
	VENTO_VELOCIDADE_2_MAXIMA = '(m/s)',
	VENTO_VELOCIDADE_2 = '(m/s)',
	VENTO_VELOCIDADE_1 = '(m/s)',
	VENTO_DIRECAO = '(°)',
	VENTO_DIRECAO_1_DESVIO_PADRAO = '(°)',
	VENTO_DIRECAO_2_DESVIO_PADRAO = '(°)',
}
